const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3000';

export const fetchClientOccupancy = async ({ limit, page, query }) => {
  try {
    const response = await fetch(`${API_URL}/client-occupancy/filter`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ limit, page, query }),
    });
    if (!response.ok) throw new Error('Error al obtener registros de ocupación');
    return await response.json();
  } catch (error) {
    console.error('Error al obtener registros de ocupación:', error);
    throw error;
  }
};

export const createClientOccupancy = async (data) => {
  try {
    const response = await fetch(`${API_URL}/client-occupancy/create`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Error al crear registro de ocupación');
    return await response.json();
  } catch (error) {
    console.error('Error al crear registro de ocupación:', error);
    throw error;
  }
};

export const updateClientOccupancy = async (id, data) => {
  try {
    const response = await fetch(`${API_URL}/client-occupancy/update/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data),
    });
    if (!response.ok) throw new Error('Error al actualizar registro de ocupación');
    return await response.json();
  } catch (error) {
    console.error('Error al actualizar registro de ocupación:', error);
    throw error;
  }
};

export const deleteClientOccupancy = async (id) => {
  try {
    const response = await fetch(`${API_URL}/client-occupancy/delete/${id}`, {
      method: 'DELETE',
    });
    if (!response.ok) throw new Error('Error al eliminar registro de ocupación');
    return await response.json();
  } catch (error) {
    console.error('Error al eliminar registro de ocupación:', error);
    throw error;
  }
};

export const exportClientOccupancy = async (query = {}) => {
  try {
    const response = await fetch(`${API_URL}/client-occupancy/export`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query }),
    });
    if (!response.ok) throw new Error('Error al exportar registros de ocupación');
    const data = await response.json();
    return data.data;
  } catch (error) {
    console.error('Error al exportar registros de ocupación:', error);
    throw error;
  }
};
